<template>
  <div id="app">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>
<style>
#app {
  min-width: 768px;
  font-family: "微软雅黑";
}

@media screen and (max-width: 992px) {
  .w1400 {
    width: 90%;
    margin: 0 auto;
  }

  /*navBar*/
  .meadia-navWidth {
    width: 100% !important;
  }

  /* index */
  .media-hide {
    display: none;
  }

  .media-mt18 {
    margin-top: 18px !important;
  }

  .media-outWeb {
    width: 22% !important;
  }

  .media-new-news-card  img {
    width: 45rem !important;
    height: 150px !important;
  }

  .media-resource {
    height: auto !important;
  }

  .meadia-resource-padding {
    padding: 20px 50px;
  }

  /* footer */
  .media-footer-cont {
    width: 100%;
  }
}

@media screen and (min-width: 992px) {
  .w1400 {
    width: 140rem;
    /*width: 72.8%;*/
    margin: 0 auto;
  }
}

@media screen and (max-width: 1200px) {
  .md-hide {
    display: none;
    visibility: hidden;
  }
}

.color {
  color: #0083CE;
}

.font12 {
  font-size: 1.2rem;
}

.font14 {
  font-size: 1.4rem;
}

.font16 {
  font-size: 1.6rem;
}

.font20 {
  font-size: 2rem;
}

.font24 {
  font-size: 2.4rem;
}

.font26 {
  font-size: 2.6rem;
}

.font32 {
  font-size: 3.2rem;
}

.font40 {
  font-size: 4rem;
}

.bold {
  font-weight: bold;
}

.cleartext {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

h1 {
  font-size: 3rem;
  text-align: center;
  margin: 2rem 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue